<template>
  <div v-loading="loading">
    <v-title :title="title">
      <div>
        <el-radio-group
          v-model="timeUnit"
          size="mini"
          style="margin-right:5px;"
          @change="handleRadioChange">
          <el-radio-button label="W">按周</el-radio-button>
          <el-radio-button label="M">按月</el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-model="date"
          size="mini"
          :unlink-panels="true"
          style="width:200px;vertical-align: top;"
          type="daterange"
          range-separator="-"
          :clearable="false"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleDateChange">
        </el-date-picker>
      </div>
    </v-title>
    <v-chart
      ref="charts"
      class="v-chart"
      :options="options"
      :init-options="{}"
      autoresize />
  </div>
</template>

<script>
import moment from 'moment'
import ECharts from '@/components/public/ECharts.vue'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import VTitle from '../v-title.vue'

export default {
  name: 'LineChart',
  components: { 'v-chart': ECharts, VTitle },
  props: {
    title: String,
    fetch: Function,
    vendorId: [Number, String]
  },
  data() {
    const start = +moment().subtract(5, 'month')
    const end = +moment()
    return {
      loading: false,
      timeUnit: 'M',
      date: [start, end],
      options: {
        // grid: {
        //   left: 30,
        //   top: 15,
        //   right: 30,
        //   bottom: 50
        // },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          // bottom: 0
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            rotate: 30
          }
        },
        yAxis: {
          type: 'value'
        },
        series: []
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    handleRadioChange() {
      this.fetchData()
    },
    handleDateChange() {
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      this.fetch({
        vendorId: this.vendorId,
        timeUnit: this.timeUnit,
        beginDate: +moment(this.date[0]).startOf('day'),
        endDate: +moment(this.date[1]).endOf('day')
      }, (res) => {
        this.loading = false
        this.options.xAxis.data = res.xAxis
        this.options.series = res.series
      }, () => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-chart {
    height 300px!important
}
</style>

